import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import get from 'lodash/get'
// UI
import styles from './cookie-policies.scss'
import CookieMapper from '../components/cookies'
import Footer from 'lemon-campaign-ui/lib/molecules/Footer'
import CookieList from './cookie-list'
import cookieListJson from './cookie-list-de.json'

class CookiePolicyTemplate extends React.Component {
  constructor(props) {
    super(props)
    const { data } = this.props

    this.state = {
      cookiesVisible: false,
    }

    this.fontColor = get(data, 'campaignData.themeId.fontColor', '#FFFFFF')
    this.linkColor = get(data, 'campaignData.themeId.buttonBackgroundColor', '#0076FF')
    this.logo = get(data, 'campaignData.headerId.content.src')
    this.layout = get(data, 'campaignData.cookieOverlay.layout', 'none')
  }

  handleLogoClick = () => {
    window.location.href = window.location.href.replace('/cookie-policy', '')
  }

  handleShowClick = () => {
    this.setState({ cookiesVisible: true })
  }

  handleAcceptClick = () => {
    this.setState({ cookiesVisible: false })
  }

  render() {
    const { data } = this.props
    const legalLink = get(data, 'campaignData.footerId.content.legalLink')

    return (
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <img src={this.logo} alt="logo" onClick={this.handleLogoClick} className={styles.logo} />
          <div className={styles.back} onClick={this.handleLogoClick}>
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14 6C14 5.44772 13.5523 5 13 5H3.83L6.71 2.12C7.10171 1.72829 7.10059 1.09284 6.70749 0.702509C6.31635 0.314123 5.68476 0.315239 5.295 0.705005L0 6L5.29451 11.2945C5.68414 11.6841 6.31586 11.6841 6.70549 11.2945C7.09474 10.9053 7.09518 10.2743 6.70647 9.88451L3.83 7H13C13.5523 7 14 6.55228 14 6Z"
                fill={this.fontColor}
              />
            </svg>
            <span style={{ color: this.fontColor }}>Zurück</span>
          </div>
        </div>
        <div className={styles.content} style={{ color: this.fontColor }}>
          <h1>Cookie Richtlinien</h1>
          <strong>Zuletzt aktualisiert am 24. September 2020</strong>

          {this.layout === 'explicit' && (
            <p>
              Um deine Cookie-Entscheidungen zu überprüfen oder zu verwalten, klicke bitte{' '}
              <span onClick={this.handleShowClick} className={styles.link} style={{ color: this.linkColor }}>
                hier
              </span>
              .
            </p>
          )}

          <h2>Einführung</h2>
          <p>
            Diese Cookie-Richtlinie erklärt, wie die Perspective Software GmbH Cookies und ähnliche Technologien
            verwendet in sog. mobile Funnels einsetzt, die mit [Perspective Funnels](https://perspective.co) erstellt
            wurden. Es wird erklärt, was diese Technologien sind und warum wir sie verwenden, sowie welche Möglichkeiten
            du hast um die Nutzung dieser Technologien einzuschränken. Mobile Funnels sind interaktive Websites und
            werden von einem Nutzer von [Perspective Funnels](https://perspective.co) veröffentlicht. Die Perspective
            Software GmbH ist der Auftragnehmer der verantwortlichen Partei und stellt der verantwortlichen Partei
            lediglich Dienste (Erstellung, Hosting, Analyse) zur Verfügung, um mit den Nutzern online via mobile Funnels
            zu interagieren. Die Perspective Software GmbH ist daher weder verantwortlich noch haftbar für jegliche
            Inhalte, Informationen und Rechtsansprüche in Bezug auf einen mobile Funnel. Informationen über den
            Verantwortlichen findest du im{' '}
            <a href={legalLink} target="_blank" rel="noreferrer noopener">
              Impressum
            </a>{' '}
            dieses mobilen Funnels.
          </p>

          <h2>Was sind Cookies</h2>
          <p>
            Wie bei fast allen professionellen Websites üblich, verwendet diese Website Cookies. Cookies sind winzige
            Dateien, die auf deinen Computer heruntergeladen werden, um deine Erfahrung zu verbessern, indem sie sie
            schneller und einfacher machen (indem sie uns helfen, zwischen dir und anderen Nutzern zu unterscheiden und
            es uns ermöglichen deine Entscheidungen temporär zu speichern). Diese Seite beschreibt, welche Informationen
            sie sammeln, wie wir sie verwenden und warum wir diese Cookies manchmal speichern müssen. Wir teilen dir
            auch mit, wie du die Speicherung dieser Cookies verhindern kannst, was jedoch dazu führen kann, dass
            bestimmte Funktionalitäten des mobile Funnel nicht mehr verfügbar sind. Von Perspective gesetzte Cookies
            werden "First-Party-Cookies" genannt. Cookies, die von anderen Parteien als Perspective gesetzt werden,
            werden "Third-Party-Cookies" genannt. Cookies von Dritten ermöglichen die Bereitstellung von Funktionen
            Dritter auf oder durch die Webseiten (z.B. Marketing, interaktive Inhalte und Analysen).
          </p>

          <h2>Wie wir Cookies verwenden</h2>
          <p>
            Leider gibt es in den meisten Fällen keine standardisierte Optionen zum Deaktivieren von Cookies, ohne die
            Funktionen und Features, die der Website vollständig zu deaktivieren. Wir empfehlen, dass Du alle Cookies
            aktiviert lässt, wenn du dir nicht sicher bist, ob du sie benötigst oder nicht um die bereitgestellten
            Dienste zu verwenden.
            <br />
            <br />
            Wir verwenden First-Party- und/oder Third-Party-Cookies in mobile Funnels für verschiedene Zwecke wie zum
            Beispiel (aber nicht ausschließlich):
            <ul>
              <li>to facilitate the operation and functionality of the mobile funnel;</li>
              <li>
                to improve your experience of the mobile funnel and make navigating around them quicker and easier;
              </li>
              <li>to identify future prospects and personalize marketing interactions with them;</li>
              <li>to facilitate the tailoring of online advertising to your interests.</li>
            </ul>
          </p>

          <h2>Abschalten von Cookies</h2>
          <p>
            Du kannst das Setzen von Cookies verhindern, indem du die Einstellungen deines Browsers anpasst (wie das
            geht, kannst du in der Hilfe deines Browsers nachlesen). Bitte beachte, dass die vollständige Deaktivierung
            von Cookies die Funktionalität dieser und vieler anderer Websites, die du besuchst, beeinträchtigt. Die
            Deaktivierung von Cookies führt in der Regel dazu, dass auch bestimmte Funktionen und Merkmale dieser
            Website deaktiviert werden. Wir empfehlen daher, dass du Cookies nicht deaktivierst. Deine Cookie
            Einstellungen kannst Du über den Cookie-Consent-Manager am Anfang dieser Richtlinie anpassen.
          </p>

          <h2>Welche Art von Cookies verwenden wir und wozu werden sie verwendet?</h2>
          <p>
            Wir verwenden die folgenden Arten von Cookies in mobile Funnels. Die Cookies, die in dem mobilen Funnel, den
            du gerade besuchest, verwendet werden, hängen von den Integrationen ab, die der Verantwortliche dieses
            Funnels verwendet. Die folgende Liste beschreibt alle möglichen Cookies. In den meisten Fällen werden nicht
            all diese Cookies in einem einzigen mobilen Funnel verwendet.
            <ul>
              <li>
                <strong>Notwendige Cookies</strong>
                <p>
                  Wir benutzen essentielle Cookies, damit die mobile Funnels funktionieren. Diese Cookies sind unbedingt
                  notwendig, um Kernfunktionen wie Sicherheit, Netzwerkverwaltung, deine Cookie-Einstellungen und
                  Erreichbarkeit zu ermöglichen. Ohne sie wärst du nicht in der Lage, grundlegende Dienste zu nutzen. Du
                  kannst diese deaktivieren, indem du die Einstellungen deines Browsers änderst, dies kann jedoch die
                  Funktionsweise der Websites beeinträchtigen.
                </p>
              </li>
              <li>
                <strong>Cookies für Marketing</strong>
                <p>
                  Diese sitzungsbasierten Marketing-Cookies ermöglichen es der verantwortlichen Partei, Nutzer zu
                  identifizieren, die an den von ihnen angebotenen Dienstleistungen und Produkten interessiert sind, und
                  helfen ihnen, weitere Interaktionen mit diesen zu personalisieren.
                </p>
              </li>
              <li>
                <strong>Cookies für Analyse</strong>
                <p>
                  Diese Cookies sammeln Informationen, die verwendet werden, um den Verantwortlichen zu helfen, zu
                  verstehen, wie die mobilen Funnels genutzt werden oder wie effektiv ihre Marketingkampagnen sind, oder
                  um uns zu helfen, den mobilen Funnel für dich anzupassen.
                  <br />
                  Eine Liste aller Analytics-Cookies findest du weiter unten.
                </p>
              </li>
              <li>
                <strong>Cookies für Medien</strong>
                <p>
                  Perspective bietet die Möglichkeit, externe Medieninhalte in die mobile Funnel zu integrieren um dem
                  Nutzer externe Medieninhalte (wie z.B. Youtube oder Vimeo-Videos) zur Verfügung zu stellen. Hierzu
                  werden Cookies benötigt. Unten findest du eine Liste von externen Medien-Cookies.
                </p>
              </li>
            </ul>
          </p>

          <h2>Third Party Cookies</h2>
          <p>
            Wenn die verantwortliche Partei des mobile Funnels diesen mit anderen Diensten (wie Facebook, Google
            Analytics, Hubspot oder anderen) integriert, verwenden wir auch Cookies, die von vertrauenswürdigen Dritten
            zur Verfügung gestellt werden. Diese Cookies können auch über den Consent-Manager oben in dieser Richtlinie
            aktiviert/deaktiviert werden. <br />
            Unten findest Du eine Liste aller Cookies. Bitte bedenken, dass die Drittparteien ihre Cookies ändern können
            und die Liste unten daher nicht alle möglichen Cookies abdecken kann, die dir in einem mobile Funnel
            begegnen können. Alle möglichen Cookies können jedoch über den Consent-Manager oben auf dieser Seite
            aktiviert/deaktiviert werden.
          </p>

          <h2 id="cookielist">Cookie Liste</h2>
          <CookieList language="de" list={cookieListJson} />

          <h2>Ähnliche Tracking-Technologien</h2>
          <p>
            Cookies sind nicht die einzige Möglichkeit, Besucher zu erkennen oder zu verfolgen. Von Zeit zu Zeit
            verwenden wir auch andere, ähnliche Technologien, wie zum Beispiel Web-Beacons (manchmal auch "Tracking
            Pixel" oder "Clear Gifs" genannt). Ihre Funktion besteht darin, uns statistische Informationen über den
            Website-Verkehr und die Art und Weise, wie Menschen durch einen mobile Funnel navigieren, zur Verfügung zu
            stellen, sowie Marketing und interessenbezogene Werbung zu erleichtern. Web-Beacons sind in der Regel
            transparente grafische Bilder, die auf einer Website platziert werden. Web-Beacons werden in Kombination mit
            Cookies verwendet, um die Aktionen von Besuchern auf Websites zu messen, so dass das Ablehnen von Cookies
            deren Funktion beeinträchtigt. Wir und unsere Marketing- und Werbepartner können Web-Beacons verwenden, um
            Informationen wie die URL der Seite, auf der der Beacon erscheint, die Zeit, zu der die Seite, die den
            Beacon enthält, angesehen wurde, und die Art des Browsers, mit dem die Seite angesehen wurde, zu erhalten.
            <br />
            <br />
            Wir verwenden außerdem Caching und lokale Speicherung in Ihrem Browser, um Personalisierungseinstellungen
            wie deine Sprache und Cookie-Auswahl zu speichern. Dies ermöglicht es uns, deine Erfahrung zu verbessern und
            Sitzungen dort fortzusetzen, wo du aufgehört hast.
          </p>
          <h2>Aktualisierungen dieser Cookie-Richtlinie</h2>
          <p>
            Wir können diese Cookie-Richtlinie von Zeit zu Zeit aktualisieren, um zum Beispiel Änderungen an den von der
            verantwortlichen Partei verwendeten Cookies zu berücksichtigen oder aus anderen betrieblichen, rechtlichen
            oder behördlichen Gründen. Bitte besuche diese Cookie-Richtlinien daher regelmäßig, um über die Verwendung
            von Cookies und verwandte Technologien informiert zu bleiben.
            <br />
            <br />
            Das Datum oben auf dieser Cookie-Richtlinie gibt an, wann sie zuletzt aktualisiert wurde.
          </p>
          <h2>Weitere Informationen</h2>
          <p>
            Hoffentlich hat das die Dinge für dich geklärt und wie bereits erwähnt, wenn du dir nicht sicher bist, ob du
            etwas brauchst oder nicht, ist es normalerweise sicherer, Cookies aktiviert zu lassen, falls sie mit einer
            der Funktionen, die du auf unserer Seite benutzt, interagiert.
            <br />
            <br />
            Wenn du dennoch nach weiteren Informationen benötigst, kannst du dich mit Perspective Software GmbH über
            eine der folgenden Kontaktmöglichkeiten in Verbindung setzen:
            <ul>
              <li>
                <strong>Website:</strong>{' '}
                <a href="https://perspective.co/en" target="_blank" rel="noreferrer noopener">
                  https://perspective.co/en
                </a>
              </li>
              <li>
                <strong>Email:</strong> <a href="mailto:privacy@perspective.co">privacy@perspective.co</a>
              </li>
            </ul>
            Für Informationen über den Verantwortlichen dieses mobile Funnels, besuche bitte das{' '}
            <a href={legalLink} target="_blank" rel="noreferrer noopener">
              Impressum
            </a>
            .
          </p>
        </div>

        <Footer
          bgColorReference={data.campaignData.themeId.backgroundColor}
          termsText={data.campaignData.footerId.content.termsText}
          termsLink={data.campaignData.footerId.content.termsLink}
          legalText={data.campaignData.footerId.content.legalText}
          legalLink={data.campaignData.footerId.content.legalLink}
        />

        <CookieMapper
          display={this.state.cookiesVisible}
          onAcceptClick={this.handleAcceptClick}
          disableCookiePoliciesLink={true}
        />
      </div>
    )
  }
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        campaignData {
          _id
          companyId
          themeId {
            buttonBackgroundColor
            fontColor
            backgroundColor
          }
          headerId {
            content {
              src
            }
          }
          cookieOverlay {
            layout
          }
          footerId {
            content {
              termsLink
              legalLink
            }
          }
        }
      }
    `}
    render={(data) => <CookiePolicyTemplate data={data} {...props} />}
  />
)
